import { render, staticRenderFns } from "./chipDetail.vue?vue&type=template&id=bf619cb0&scoped=true&"
import script from "./chipDetail.vue?vue&type=script&lang=js&"
export * from "./chipDetail.vue?vue&type=script&lang=js&"
import style0 from "./chipDetail.vue?vue&type=style&index=0&id=bf619cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf619cb0",
  null
  
)

export default component.exports